import util from '@bmp-vue/core/api/util'

const controller = 'ParceiroSlc'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {
    GetAllParceirosSlc: function (dto) {
      return util.Axios.GetAll(controller, dto)
    },
    CreateParceiroSlc: function (dto) {
      return util.Axios.Post(controller, dto); 
    },
    ImportarParceiroSlc: function (dto, codigoParceiro) {
      return util.Axios.Post(controller + '/Lote' + `/${codigoParceiro}`, dto); 
    },
    AtualizarParceiroSlc: function (dto) {
      return util.Axios.Put(controller, '', dto);
    },
  })
  